"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.voice-agent.disabled': 'La funzione agente vocale non è disponibile nel tuo piano attuale.',
};
